import { createReducer } from 'redux-starter-kit';
import { selectRequest } from '../../domain/requests/RequestReducer';
import { submitSupportTicket } from './supportUiActions';


/**
 * A Selector for the submitTicket request
 */
export const selectSubmitSupportTicketRequest = (state) => {
  const requestId = state.via.ui.support.submitSupportTicketRequestId;
  if (!requestId) return null;

  return selectRequest(state, requestId);
};

const initialSupportState = {
  submitSupportTicketRequestId: null,
};

/**
 * A reducer for support ticket requests.
 */
const supportUiReducer = createReducer(initialSupportState, {

  [submitSupportTicket]: (state, action) => ({
    ...state,
    submitSupportTicketRequestId: action.payload.requestId,
  }),

});

export default supportUiReducer;
